import React, { useEffect, useContext, useState } from 'react'
import ProductService from '../../../../../../services/api/product.service'
import ModalBox from '../../../../../templates/components/ModalBox'
import Table2 from '../../../../../templates/components/Table2'
import AddProductTag from './AddProductTag'
import EditProductTag from './EditProductTag'

const ProductTagSettings = (props) => {
    const [isLoader, setIsLoader] = useState(false)
    const [tags, setTags] = useState()
    const [selectedTag, setSelectedTag] = useState()
    const [add, setAdd] = useState(false)
    const [edit, setEdit] = useState(false)
    const findAllTags = () =>{
        ProductService.getAllLookupTags()
        .then(res=>{
            console.log(res.data)
            setTags(res.data)
        })
        .catch(err=>{
            console.log(err)
        })
    }
    const columns = [
        {
          id: "name",
          Header: "Name",
          accessor: tag=>tag.name
        },
        {
          id: "actionPracticePatient",
          Header: "Action",
          textAlign: "center",
          disableSortBy: true,
          accessor: (product, i) => {
            return (
              <div className="d-flex justify-content-center">
                <button
                  className="p-0 ps-1 btn btn-primary"
                  title="Edit Product"
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedTag(product);
                    return setEdit(true);
                  }}
                >
                  <i className="icon pencil" />
                </button>
              </div>
            );
          },
        },
      ];

    useEffect(()=>{
        findAllTags()
    },[])
    return (
        <div className='d-flex row'>
            <Table2 export searchable data={tags} loading={isLoader} columns={columns}
            extraButtons={[
                {className:'btn btn-primary', children: <i className='icon plus'/>, title:'Add Tag', onClick:()=>{setAdd(true)}}
            ]}/>
            <ModalBox open={add} onClose={()=>{setAdd(false)}} title={"Add Tag"} size="tiny">
               <AddProductTag onClose={()=>{setAdd(false)}} refresh={() => { findAllTags() }}/>
            </ModalBox>
            <ModalBox open={edit} onClose={()=>{setEdit(false)}} title={"Edit Tag"} size="tiny">
               <EditProductTag initialData={selectedTag} onClose={()=>{setEdit(false)}} refresh={() => { findAllTags() }}/>
            </ModalBox>
        </div>
    )
}
export default ProductTagSettings